type Resource = {
  width: number;
  height: number;
};

export function calculateSize(resource: Resource, maxWidth: number) {
  const ratio = maxWidth / resource.width;
  const width = resource.width * ratio;
  const height = resource.height * ratio;

  return [width, height];
}
